var map = {
	"./img_1.jpg": 46668,
	"./img_2.jpg": 66724,
	"./img_3.jpg": 59398,
	"./img_4.jpg": 19546,
	"./img_5.jpg": 63573,
	"./img_6.jpg": 83675,
	"./img_7.jpg": 9003,
	"./img_8.jpg": 25754,
	"./img_9.jpg": 77480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79637;